var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.title,
        width: "1000px",
        "close-on-click-modal": false
      },
      on: { close: _vm.onClose }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-width": "100px",
            "label-position": "left",
            model: _vm.form,
            "show-message": false
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "包装号",
                        required: "",
                        prop: "packageNo"
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.packageNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "packageNo", $$v)
                          },
                          expression: "form.packageNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "包装类型",
                        required: "",
                        prop: "packageType"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "select-type": _vm.selectTypeNames.basic_data_Packing,
                          filterable: "",
                          "default-value": _vm.form.packageType,
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.form.packageType = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { display: "flex" }, attrs: { gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "volume-col",
                      attrs: { required: "", label: "单箱体积" }
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "-4px" },
                          attrs: { span: 4 }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { required: "", prop: "estimatedLength" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "长(CM)" },
                                model: {
                                  value: _vm.form.estimatedLength,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "estimatedLength", $$v)
                                  },
                                  expression: "form.estimatedLength"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 1 }
                        },
                        [_vm._v("x")]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", prop: "estimatedWidth" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "宽(CM)" },
                                model: {
                                  value: _vm.form.estimatedWidth,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "estimatedWidth", $$v)
                                  },
                                  expression: "form.estimatedWidth"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 1 }
                        },
                        [_vm._v("x")]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { required: "", prop: "estimatedHeight" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "高(CM)" },
                                model: {
                                  value: _vm.form.estimatedHeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "estimatedHeight", $$v)
                                  },
                                  expression: "form.estimatedHeight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 1 }
                        },
                        [_vm._v("=")]
                      ),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v(_vm._s(_vm.form.estimatedUnitCubage))
                      ]),
                      _c("el-col", { attrs: { span: 3 } }, [_vm._v("CBM")])
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 8 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "单箱重量",
                                required: "",
                                prop: "estimatedUnitGrossWeight"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.estimatedUnitGrossWeight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "estimatedUnitGrossWeight",
                                      $$v
                                    )
                                  },
                                  expression: "form.estimatedUnitGrossWeight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 3 } }, [_vm._v("KGS")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "flex-grow": "1",
                    display: "flex",
                    "align-items": "center",
                    "margin-top": "0"
                  },
                  attrs: { span: 3 }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 8 } },
                    [
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("x")]),
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "0",
                                required: "",
                                prop: "estimatedQuantity"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "箱数" },
                                model: {
                                  value: _vm.form.estimatedQuantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "estimatedQuantity", $$v)
                                  },
                                  expression: "form.estimatedQuantity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("=")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 6 } }, [_vm._v("总体积")]),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 12 }
                        },
                        [_vm._v(_vm._s(_vm.form.estimatedCubage))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 6 }
                        },
                        [_vm._v("CBM")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 6 } }, [_vm._v("总重量")]),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 12 }
                        },
                        [_vm._v(_vm._s(_vm.form.estimatedGrossWeight))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 6 }
                        },
                        [_vm._v("KGS")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "生产商", prop: "producerId" } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          "default-value": _vm.form.producerId || "",
                          "tag-name": "chineseName",
                          "method-params": { factorySign: true }
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.form.producerId = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "预计货好时间",
                        prop: "estimatedIncomeDate"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "date", clearable: "" },
                        model: {
                          value: _vm.form.estimatedIncomeDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estimatedIncomeDate", $$v)
                          },
                          expression: "form.estimatedIncomeDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "实际进仓时间", prop: "incomeDate" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "", type: "date", clearable: "" },
                        model: {
                          value: _vm.form.warehouseInDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "warehouseInDate", $$v)
                          },
                          expression: "form.warehouseInDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "注意事项", prop: "matters" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.matters,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "matters", $$v)
                  },
                  expression: "form.matters"
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAddGoods }
                    },
                    [_vm._v("添加商品")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "goodsTable",
              attrs: { data: _vm.form.poPackageItemList, size: "medium" }
            },
            [
              _c(
                "el-table-column",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "poPackageItemList." +
                                  scope.$index +
                                  ".poInfoUuid",
                                "label-width": "0",
                                required: ""
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  remote: true,
                                  cache: false,
                                  filterable: "",
                                  url: _vm.URL.order.searchPoInfoByPoNo,
                                  wait: 0,
                                  "default-value": scope.row.poInfoUuid,
                                  "remote-default-obj": {
                                    poNo: scope.row.poNo,
                                    uuid: scope.row.poInfoUuid
                                  },
                                  "method-params": {
                                    customerId: _vm.customerId
                                  },
                                  "tag-name": "poNo",
                                  "tag-value": "uuid"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.poPackageItemList[
                                      scope.$index
                                    ].poInfoUuid = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*")
                    ]),
                    _vm._v("订单号")
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "poPackageItemList." +
                                  scope.$index +
                                  ".poItemUuid",
                                "label-width": "0",
                                required: ""
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: !scope.row.poInfoUuid,
                                  remote: true,
                                  cache: false,
                                  filterable: "",
                                  url: _vm.URL.order.searchPoItem,
                                  wait: 0,
                                  "remote-keyword-length": 1,
                                  "default-value": scope.row.poItemUuid,
                                  "method-params": {
                                    poInfoUuid: scope.row.poInfoUuid
                                  },
                                  "remote-default-obj": {
                                    itemNo: scope.row.itemNo,
                                    uuid: scope.row.poItemUuid
                                  },
                                  fields: [
                                    "itemNo",
                                    "chineseCommodity",
                                    "englishCommodity"
                                  ],
                                  headers: ["SKU编码", "中文名称", "英文名称"],
                                  "tag-name": "itemNo",
                                  "tag-value": "uuid"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.poItemSelected(p, scope.$index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*")
                    ]),
                    _vm._v("SKU编码")
                  ])
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "中文品名", prop: "chineseCommodity" }
              }),
              _c("el-table-column", {
                attrs: { label: "英文品名", prop: "englishCommodity" }
              }),
              _c(
                "el-table-column",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "poPackageItemList." +
                                  scope.$index +
                                  ".quantity",
                                "label-width": "0",
                                required: ""
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: scope.row.quantity,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "quantity", $$v)
                                  },
                                  expression: "scope.row.quantity"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*")
                    ]),
                    _vm._v("SKU数量")
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "poPackageItemList." +
                                  scope.$index +
                                  ".cartonQuantity",
                                "label-width": "0"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: scope.row.cartonQuantity,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "cartonQuantity", $$v)
                                  },
                                  expression: "scope.row.cartonQuantity"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("template", { slot: "header" }, [_vm._v("纸箱数")])],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.handleDelGoods(scope.$index)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-form", [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                  [_vm._v("保存")]
                ),
                _c("el-button", { on: { click: _vm.onClose } }, [
                  _vm._v("取消")
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }